import React, { useContext } from 'react';
import { useNavigate } from 'react-router-dom';
import { LeagueContext, LeagueContextData } from '../../components/layouts/LeagueLayout';
import Card from '../../components/common/Card';
import DraftBoard from '../../components/draft/DraftBoard';
import GradingLoader from '../../components/common/GradingLoader';

const LeagueDraftBoard: React.FC = () => {
  const context = useContext(LeagueContext) as LeagueContextData;
  const navigate = useNavigate();
  const { draftAnalysis, espnLeagueId } = context;

  // Link team names to the team roster page under the current league route.
  const handleTeamClick = (teamId: number) => {
    navigate(`/leagues/espn/${espnLeagueId}/teams/${teamId}`);
  };

  const handlePlayerClick = (playerId: number) => {
    navigate(`/leagues/espn/${espnLeagueId}/players/${playerId}`);
  };

  if (!draftAnalysis) {
    return (
      <Card className="p-6">
        <GradingLoader label="Scoring every pick…" size="lg" className="py-12" />
      </Card>
    );
  }

  return (
    <DraftBoard 
      leagueId={parseInt(espnLeagueId)} 
      onTeamSelect={handleTeamClick}
      onPlayerSelect={handlePlayerClick}
    />
  );
};

export default LeagueDraftBoard;